import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  List,
  ListItem,
  Typography,
  useMediaQuery,
} from '@mui/material';
import fileShieldIcon from 'assets/icons/file-shield,.svg';
import shieldIcon from 'assets/icons/shield.svg';
import vectorIcon from 'assets/icons/vector.svg';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import theme from 'providers/theme/theme';
import { type FC, Fragment } from 'react';
import contents from '../CoverageDetails.json';
import {
  AccordionDetailsStyle,
  AccordionStyle,
  AccordionSummaryStyle,
  ContentWrapperStyle,
  ListItemStyle,
  ListStyle,
} from './CoverageDetailsContent.styles';
import type {
  CoverageDetailsContentProps,
  ICoverageDetailsContent,
} from './CoverageDetailsContent.types';

const icons = {
  fileShieldIcon,
  shieldIcon,
};

const CoverageDetailsContent: FC<CoverageDetailsContentProps> = ({ detailsKey }) => {
  const coverageDetails: ICoverageDetailsContent = contents[detailsKey];
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('sm'));

  if (!coverageDetails) return null;

  return (
    <Box sx={ContentWrapperStyle}>
      <Typography variant="specialInfo">{coverageDetails.title}</Typography>
      <Typography>{coverageDetails.description}</Typography>

      <Box>
        {coverageDetails?.lists.map((list, idx) => (
          <Fragment key={list.title}>
            <Accordion
              sx={AccordionStyle}
              disabled={!isMobileLayout}
              expanded={!isMobileLayout || undefined}
            >
              <AccordionSummary
                sx={AccordionSummaryStyle}
                expandIcon={isMobileLayout && <SvgIconWrapper src={vectorIcon} />}
              >
                {list?.icon && <SvgIconWrapper src={icons[list.icon]} />}
                <Typography variant="h3">{list.title}</Typography>
              </AccordionSummary>

              <AccordionDetails sx={AccordionDetailsStyle}>
                <List sx={ListStyle}>
                  {list.listItems?.map((situation) => (
                    <ListItem key={situation} sx={ListItemStyle}>
                      <Typography>{situation}</Typography>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>

            {idx < coverageDetails.lists.length - 1 && <Divider />}
          </Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default CoverageDetailsContent;
